export const THUMBNAIL_SIZE = 42
export const ICON_SIZE = 24
export const LOADING_SIZE_BY_SIZE = {
  small: 16,
  medium: 16,
  large: 32,
} as const
